(function () {

  /* =========================================================
     API
  ========================================================== */

  var SELLER_API_BASE =
    'https://s.nijikart.com/api/sellers/';


  /* =========================================================
     GET SELLER SLUG
  ========================================================== */

  var params =
    new URLSearchParams(
      window.location.search
    );


  var vendorSlug =
    params.get('v') ||
    params.get('vendor');


  /* =========================================================
     MAIN ELEMENTS
  ========================================================== */

  var loadingEl =
    document.getElementById(
      'seller-loading'
    );


  var contentEl =
    document.getElementById(
      'seller-page-content'
    );


  var notFoundEl =
    document.getElementById(
      'seller-not-found'
    );


  /* =========================================================
     PAGE STATE
  ========================================================== */

  function showLoading() {

    if (loadingEl) {
      loadingEl.style.display =
        'flex';
    }


    if (contentEl) {
      contentEl.style.display =
        'none';
    }


    if (notFoundEl) {
      notFoundEl.style.display =
        'none';
    }

  }


  function showContent() {

    if (loadingEl) {
      loadingEl.style.display =
        'none';
    }


    if (notFoundEl) {
      notFoundEl.style.display =
        'none';
    }


    if (contentEl) {
      contentEl.style.display =
        'block';
    }

  }


  function showNotFound() {

    if (loadingEl) {
      loadingEl.style.display =
        'none';
    }


    if (contentEl) {
      contentEl.style.display =
        'none';
    }


    if (notFoundEl) {
      notFoundEl.style.display =
        'block';
    }

  }


  /* =========================================================
     TEXT HELPERS
  ========================================================== */

  function setText(
    id,
    value
  ) {

    var element =
      document.getElementById(
        id
      );


    if (!element) {
      return;
    }


    element.textContent =
      value == null
        ? ''
        : String(value);

  }


  function setOptionalText(
    id,
    value
  ) {

    var element =
      document.getElementById(
        id
      );


    if (!element) {
      return;
    }


    if (
      value !== null &&
      value !== undefined &&
      String(value).trim() !== ''
    ) {

      element.textContent =
        String(value).trim();


      element.style.display =
        '';

    } else {

      element.textContent =
        '';


      element.style.display =
        'none';

    }

  }


  /* =========================================================
     NORMALIZE VENDOR
  ========================================================== */

  function normalizeVendor(
    value
  ) {

    return String(
      value || ''
    )
    .toLowerCase()
    .replace(
      /[^a-z0-9]/g,
      ''
    );

  }


  /* =========================================================
     INITIALS
  ========================================================== */

  function getSellerInitials(
    name
  ) {

    if (!name) {
      return 'S';
    }


    var words =
      String(name)
      .trim()
      .split(/\s+/)
      .filter(Boolean);


    if (!words.length) {
      return 'S';
    }


    if (words.length === 1) {

      return words[0]
        .substring(
          0,
          2
        )
        .toUpperCase();

    }


    return (
      words[0].charAt(0) +
      words[
        words.length - 1
      ].charAt(0)
    ).toUpperCase();

  }


  /* =========================================================
     IMAGE HELPER
  ========================================================== */

  function setSellerImage(
    imageId,
    src,
    alt,
    fallbackId
  ) {

    var image =
      document.getElementById(
        imageId
      );


    var fallback =
      fallbackId
        ? document.getElementById(
            fallbackId
          )
        : null;


    if (!image) {
      return;
    }


    if (
      src &&
      String(src).trim()
    ) {

      image.onload =
        function () {

          image.style.display =
            'block';


          if (fallback) {

            fallback.style.display =
              'none';

          }

        };


      image.onerror =
        function () {

          image.style.display =
            'none';


          if (fallback) {

            fallback.style.display =
              '';

          }

        };


      image.src =
        String(src).trim();


      image.alt =
        alt || '';

    } else {

      image.removeAttribute(
        'src'
      );


      image.style.display =
        'none';


      if (fallback) {

        fallback.style.display =
          '';

      }

    }

  }


  /* =========================================================
     GET SELLER SHOPIFY VENDOR NAME
  ========================================================== */

  function getShopifyVendorName(
    data
  ) {

    return (
      data.shop_name ||
      data.seller_shop_name ||
      data.display_name ||
      data.seller_name ||
      vendorSlug
    );

  }


  /* =========================================================
     RENDER SELLER PROFILE
  ========================================================== */

  function renderSellerProfile(
    data
  ) {

    /* -------------------------------------------------------
       STORE NAME
    -------------------------------------------------------- */

    var storeName =
      data.display_name ||
      data.shop_name ||
      data.seller_shop_name ||
      data.seller_name ||
      vendorSlug ||
      'Seller';


    setText(
      'seller-name',
      storeName
    );


    setText(
      'seller-about-name',
      storeName
    );


    /* -------------------------------------------------------
       LOCATION

       Your current API already returns:
       location

       Fallback builds location from
       city/state/country.
    -------------------------------------------------------- */

    var location =
      data.location ||
      [
        data.store_city,
        data.store_state,
        data.store_country
      ]
      .filter(Boolean)
      .join(', ');


    setOptionalText(
      'seller-location',
      location
    );


    /* -------------------------------------------------------
       SHORT DESCRIPTION

       Your API fields supported:
       short_store_description
       bio
       store_description
    -------------------------------------------------------- */

    var shortDescription =
      data.short_store_description ||
      data.bio ||
      data.store_description ||
      '';


    setOptionalText(
      'seller-bio',
      shortDescription
    );


    /* -------------------------------------------------------
       AVATAR / SHOP LOGO

       Uses only values returned by your API.
    -------------------------------------------------------- */

    var avatarUrl =
      data.avatar_url ||
      data.profile_image_url ||
      data.shop_logo_url ||
      '';


    var initials =
      document.getElementById(
        'seller-initials'
      );


    if (initials) {

      initials.textContent =
        getSellerInitials(
          storeName
        );

    }


    setSellerImage(
      'seller-avatar',
      avatarUrl,
      storeName,
      'seller-initials'
    );


    /* -------------------------------------------------------
       BANNER

       Your API:
       banner_url
       store_banner_url
    -------------------------------------------------------- */

    var bannerUrl =
      data.banner_url ||
      data.store_banner_url ||
      '';


    setSellerImage(
      'seller-banner-img',
      bannerUrl,
      storeName + ' banner',
      'seller-banner-placeholder'
    );


    /* -------------------------------------------------------
   ABOUT

   API FIELD:
   about

   This section appears immediately
   after Items.
-------------------------------------------------------- */

var aboutDescription =
  data.about ||
  '';


var aboutTab =
  document.getElementById(
    'seller-about-tab'
  );


var aboutSection =
  document.getElementById(
    'seller-section-about'
  );


var aboutContent =
  document.getElementById(
    'seller-about-description'
  );


if (
  aboutDescription &&
  String(aboutDescription).trim()
) {

  /*
   * Add API about content
   */
  if (aboutContent) {

    aboutContent.textContent =
      String(
        aboutDescription
      ).trim();

  }


  /*
   * Show About navigation
   */
  if (aboutTab) {

    aboutTab.style.display =
      '';

  }


  /*
   * Show About section
   */
  if (aboutSection) {

    aboutSection.style.display =
      '';

  }

} else {

  /*
   * No About data from API,
   * hide both navigation and section.
   */

  if (aboutTab) {

    aboutTab.style.display =
      'none';

  }


  if (aboutSection) {

    aboutSection.style.display =
      'none';

  }

}

    /* -------------------------------------------------------
       SHOP POLICIES

       Shown ONLY when seller_policy
       contains data.
    -------------------------------------------------------- */

    var sellerPolicy =
      data.seller_policy ||
      '';


    var policyTab =
      document.getElementById(
        'seller-policy-tab'
      );


    var policySection =
      document.getElementById(
        'seller-section-policies'
      );


    var policyContent =
      document.getElementById(
        'seller-policy'
      );


    if (
      sellerPolicy &&
      String(
        sellerPolicy
      ).trim()
    ) {

      if (policyContent) {

        policyContent.textContent =
          String(
            sellerPolicy
          ).trim();

      }


      if (policyTab) {

        policyTab.style.display =
          '';

      }


      if (policySection) {

        policySection.style.display =
          '';

      }

    } else {

      if (policyTab) {

        policyTab.style.display =
          'none';

      }


      if (policySection) {

        policySection.style.display =
          'none';

      }

    }


    /* -------------------------------------------------------
       CONTACT

       Only shown if seller_contact
       is returned by Django.

       seller_email is deliberately
       not displayed publicly.
    -------------------------------------------------------- */

    var contactButton =
      document.getElementById(
        'seller-contact-btn'
      );


    if (
      contactButton &&
      data.seller_contact &&
      String(
        data.seller_contact
      ).trim()
    ) {

      var sellerContact =
        String(
          data.seller_contact
        ).trim();


      /*
       * If Django already returns URL,
       * use it directly.
       *
       * Otherwise assume phone number.
       */

      if (
        sellerContact.indexOf(
          'http://'
        ) === 0 ||
        sellerContact.indexOf(
          'https://'
        ) === 0
      ) {

        contactButton.href =
          sellerContact;

      } else {

        contactButton.href =
          'tel:' +
          sellerContact.replace(
            /\s+/g,
            ''
          );

      }


      contactButton.style.display =
        'inline-flex';

    } else if (contactButton) {

      contactButton.style.display =
        'none';

    }


    /* -------------------------------------------------------
       VIEW ALL PRODUCTS
    -------------------------------------------------------- */

    setupViewAllProducts(
      getShopifyVendorName(
        data
      )
    );

  }


  /* =========================================================
     VIEW ALL PRODUCTS
  ========================================================== */

  function setupViewAllProducts(
    vendorName
  ) {

    var link =
      document.getElementById(
        'seller-view-all-products'
      );


    var wrap =
      document.getElementById(
        'seller-view-all-wrap'
      );


    if (
      !link ||
      !wrap ||
      !vendorName
    ) {
      return;
    }


    link.href =
      '/collections/vendors?q=' +
      encodeURIComponent(
        vendorName
      );


    wrap.style.display =
      'block';

  }


  /* =========================================================
     LOAD SHOPIFY PRODUCTS
  ========================================================== */

  function loadShopifyProducts(
    seller
  ) {

    var sellerVendorName =
      getShopifyVendorName(
        seller
      );


    var shopifyRoot =
      (
        window.Shopify &&
        window.Shopify.routes &&
        window.Shopify.routes.root
      )
        ? window.Shopify.routes.root
        : '/';


    var url =
      shopifyRoot +
      'search/suggest.json' +
      '?q=' +
      encodeURIComponent(
        sellerVendorName
      ) +
      '&resources[type]=product' +
      '&resources[limit]=10' +
      '&_=' +
      Date.now();


    return fetch(
      url,
      {
        credentials:
          'same-origin'
      }
    )
    .then(
      function (
        response
      ) {

        if (!response.ok) {

          throw new Error(
            'Shopify product request failed: ' +
            response.status
          );

        }


        return response.json();

      }
    )
    .then(
      function (
        responseData
      ) {

        var products =
          (
            responseData &&
            responseData.resources &&
            responseData.resources.results &&
            responseData.resources.results.products
          )
            ? responseData.resources.results.products
            : [];


        var expectedVendor =
          normalizeVendor(
            sellerVendorName
          );


        /*
         * Keep ONLY exact seller products.
         */
        products =
          products.filter(
            function (
              product
            ) {

              var tagMatch =
                (product.tags || []).some(
                  function (tag) {
                    return (
                      normalizeVendor(tag) === expectedVendor ||
                      normalizeVendor(tag) === normalizeVendor('seller_' + sellerVendorName) ||
                      normalizeVendor(tag) === normalizeVendor('seller:' + sellerVendorName)
                    );
                  }
                );


              return (
                (
                  product.vendor &&
                  normalizeVendor(
                    product.vendor
                  ) === expectedVendor
                ) ||
                tagMatch
              );

            }
          );


        renderProducts(
          products,
          seller
        );


        return products;

      }
    )
    .catch(
      function (
        error
      ) {

        console.error(
          '[Seller Storefront] Product error:',
          error
        );


        var grid =
          document.getElementById(
            'seller-products-grid'
          );


        if (grid) {

          grid.innerHTML =
            '<div class="seller-search-empty">' +
              'Products could not be loaded.' +
            '</div>';

        }


        updateProductCount(
          seller,
          0
        );

      }
    );

  }


  /* =========================================================
     RENDER PRODUCTS
  ========================================================== */

  function renderProducts(
    products,
    seller
  ) {

    var grid =
      document.getElementById(
        'seller-products-grid'
      );


    if (!grid) {
      return;
    }


    grid.innerHTML =
      '';


    if (!products.length) {

      var empty =
        document.createElement(
          'div'
        );


      empty.className =
        'seller-search-empty';


      empty.textContent =
        'No products found for this seller.';


      grid.appendChild(
        empty
      );


      updateProductCount(
        seller,
        0
      );


      return;

    }


    products.forEach(
      function (
        product
      ) {

        grid.appendChild(
          createProductCard(
            product
          )
        );

      }
    );


    updateProductCount(
      seller,
      products.length
    );

    initializeSellerCatalog();

  }


  /* =========================================================
     CREATE PRODUCT CARD
  ========================================================== */

  function createProductCard(
    product
  ) {

    var card =
      document.createElement(
        'article'
      );


    card.className =
      'seller-product-card';


    card.dataset.productTitle =
      String(
        product.title ||
        ''
      );

    var productTags = Array.isArray(product.tags)
      ? product.tags
      : String(product.tags || '').split(',');
    var productSection = String(
      product.product_type ||
      product.type ||
      productTags[0] ||
      'Other Items'
    ).trim();
    var productPrice = parseFloat(product.price_min || product.price || 0);

    card.dataset.productSection = productSection;
    card.dataset.productSearch = [
      product.title || '',
      product.vendor || '',
      productSection,
      productTags.join(' ')
    ].join(' ').toLowerCase();
    card.dataset.productPrice = isNaN(productPrice) ? '0' : String(productPrice);
    card.dataset.featuredOrder = String(document.querySelectorAll('#seller-products-grid .seller-product-card').length);


    /* -------------------------------------------------------
       LINK
    -------------------------------------------------------- */

    var link =
      document.createElement(
        'a'
      );


    link.className =
      'seller-product-link';


    link.href =
      product.url ||
      '#';


    /* -------------------------------------------------------
       IMAGE WRAPPER
    -------------------------------------------------------- */

    var imageWrap =
      document.createElement(
        'div'
      );


    imageWrap.className =
      'seller-product-image-wrap';


    /* -------------------------------------------------------
       IMAGE
    -------------------------------------------------------- */

    var image =
      document.createElement(
        'img'
      );


    var imageUrl =
      (
        product.featured_image &&
        product.featured_image.url
      ) ||
      product.image ||
      '';


    if (imageUrl) {

      image.src =
        imageUrl;

    }


    image.alt =
      product.title ||
      'Product';


    image.loading =
      'lazy';


    imageWrap.appendChild(
      image
    );


    /* -------------------------------------------------------
       TITLE
    -------------------------------------------------------- */

    var title =
      document.createElement(
        'p'
      );


    title.className =
      'seller-product-title';


    title.textContent =
      product.title ||
      'Product';


    link.appendChild(
      imageWrap
    );


    link.appendChild(
      title
    );


    /* -------------------------------------------------------
       PRICE
    -------------------------------------------------------- */

    var price =
      parseFloat(
        product.price_min ||
        product.price ||
        0
      );


    var comparePrice =
      parseFloat(
        product.compare_at_price_min ||
        product.compare_at_price_max ||
        0
      );


    if (
      !isNaN(price) &&
      price > 0
    ) {

      var pricing =
        document.createElement(
          'div'
        );


      pricing.className =
        'seller-product-pricing';


      var priceElement =
        document.createElement(
          'span'
        );


      priceElement.className =
        'seller-product-price';


      priceElement.textContent =
        formatMoney(
          price
        );


      pricing.appendChild(
        priceElement
      );


      if (
        !isNaN(comparePrice) &&
        comparePrice > price
      ) {

        var compareElement =
          document.createElement(
            'span'
          );


        compareElement.className =
          'seller-product-compare-price';


        compareElement.textContent =
          formatMoney(
            comparePrice
          );


        pricing.appendChild(
          compareElement
        );

      }


      link.appendChild(
        pricing
      );

    }


    card.appendChild(
      link
    );


    return card;

  }


  /* =========================================================
     PRODUCT COUNT
  ========================================================== */

  function updateProductCount(
    seller,
    loadedCount
  ) {

    /*
     * If Django later gives exact
     * product count, use it.
     */

    var exactCount =
      seller.product_count ??
      seller.products_count ??
      null;


    var displayCount;


    if (
      exactCount !== null &&
      exactCount !== undefined &&
      exactCount !== ''
    ) {

      displayCount =
        Number(
          exactCount
        );

    } else {

      /*
       * Current Shopify request
       * loads maximum 10.
       */

      displayCount =
        loadedCount >= 10
          ? '10+'
          : loadedCount;

    }


    setText(
      'seller-product-count',
      displayCount
    );


    var productsStat =
      document.getElementById(
        'products-stat'
      );


    if (productsStat) {

      productsStat.style.display =
        'flex';

    }


    var headingCount =
      document.getElementById(
        'seller-products-heading-count'
      );


    if (headingCount) {

      if (
        displayCount ===
        '10+'
      ) {

        headingCount.textContent =
          '10+ products';

      } else {

        headingCount.textContent =
          displayCount +
          (
            Number(
              displayCount
            ) === 1
              ? ' product'
              : ' products'
          );

      }

    }

  }


  /* =========================================================
     PRICE FORMAT
  ========================================================== */

  function formatMoney(
    amount
  ) {

    var currency =
      (
        window.Shopify &&
        window.Shopify.currency &&
        window.Shopify.currency.active
      )
        ? window.Shopify.currency.active
        : 'INR';


    try {

      return new Intl.NumberFormat(
        'en-IN',
        {
          style:
            'currency',

          currency:
            currency,

          maximumFractionDigits:
            0
        }
      ).format(
        Number(
          amount
        )
      );

    } catch (
      error
    ) {

      return (
        '₹' +
        Number(
          amount
        ).toFixed(0)
      );

    }

  }


  /* =========================================================
     LOCAL PRODUCT SEARCH
  ========================================================== */

  var activeSellerSection = 'all';

  function sellerSectionKey(value) {
    return String(value || 'Other Items').trim().toLowerCase();
  }

  function initializeSellerCatalog() {
    var cards = Array.prototype.slice.call(document.querySelectorAll('#seller-products-grid .seller-product-card'));
    var sectionCounts = {};

    cards.forEach(function (card, index) {
      card.dataset.featuredOrder = String(index);
      var label = card.dataset.productSection || 'Other Items';
      var key = sellerSectionKey(label);
      if (!sectionCounts[key]) sectionCounts[key] = { label: label, count: 0 };
      sectionCounts[key].count++;
    });

    var allCount = document.getElementById('seller-section-all-count');
    if (allCount) allCount.textContent = String(cards.length);

    var sections = document.getElementById('seller-dynamic-sections');
    if (sections) {
      sections.innerHTML = '';
      Object.keys(sectionCounts).sort(function (a, b) {
        return sectionCounts[a].label.localeCompare(sectionCounts[b].label);
      }).forEach(function (key) {
        var item = sectionCounts[key];
        var button = document.createElement('button');
        button.type = 'button';
        button.className = 'seller-section-filter';
        button.dataset.sellerSection = key;
        var label = document.createElement('span');
        label.textContent = item.label;
        var count = document.createElement('strong');
        count.textContent = String(item.count);
        button.appendChild(label);
        button.appendChild(count);
        sections.appendChild(button);
      });
    }

    filterProducts(document.getElementById('seller-product-search') ? document.getElementById('seller-product-search').value : '');
  }

  function filterProducts(query) {
    var grid = document.getElementById('seller-products-grid');
    var cards = Array.prototype.slice.call(document.querySelectorAll('#seller-products-grid .seller-product-card'));
    var cleanQuery = String(query || '').trim().toLowerCase();
    var sort = document.getElementById('seller-product-sort');
    var sortValue = sort ? sort.value : 'featured';

    cards.sort(function (a, b) {
      if (sortValue === 'price-asc') return Number(a.dataset.productPrice || 0) - Number(b.dataset.productPrice || 0);
      if (sortValue === 'price-desc') return Number(b.dataset.productPrice || 0) - Number(a.dataset.productPrice || 0);
      if (sortValue === 'title-asc') return String(a.dataset.productTitle || '').localeCompare(String(b.dataset.productTitle || ''));
      return Number(a.dataset.featuredOrder || 0) - Number(b.dataset.featuredOrder || 0);
    });
    if (grid) cards.forEach(function (card) { grid.appendChild(card); });

    var visibleCount = 0;
    cards.forEach(function (card) {
      var matchesQuery = !cleanQuery || String(card.dataset.productSearch || card.dataset.productTitle || '').indexOf(cleanQuery) !== -1;
      var matchesSection = activeSellerSection === 'all' || sellerSectionKey(card.dataset.productSection) === activeSellerSection;
      var visible = matchesQuery && matchesSection;
      card.style.display = visible ? '' : 'none';
      if (visible) visibleCount++;
    });

    var empty = document.getElementById('seller-search-empty');
    if (empty) empty.style.display = cards.length && visibleCount === 0 ? 'block' : 'none';
    var visibleCountElement = document.getElementById('seller-visible-product-count');
    if (visibleCountElement) visibleCountElement.textContent = String(visibleCount);
    var clear = document.getElementById('seller-clear-filters');
    if (clear) clear.style.display = cleanQuery || activeSellerSection !== 'all' ? '' : 'none';
  }


  /* =========================================================
     SMOOTH SECTION SCROLL
  ========================================================== */

  function scrollToSellerSection(
    sectionId
  ) {

    var section =
      document.getElementById(
        sectionId
      );


    if (!section) {
      return;
    }


    section.scrollIntoView(
      {
        behavior:
          'smooth',

        block:
          'start'
      }
    );

  }


  /* =========================================================
     NAVIGATION CLICK
  ========================================================== */

  function activateSellerSection(targetId, keepNavigationVisible) {
    var target = document.getElementById(targetId);
    if (!target) return;

    document.querySelectorAll('.seller-page-section').forEach(function (section) {
      var active = section.id === targetId;
      section.style.display = active ? '' : 'none';
      section.hidden = !active;
      section.setAttribute('aria-hidden', active ? 'false' : 'true');
    });

    document.querySelectorAll('.seller-tab').forEach(function (tab) {
      var active = tab.getAttribute('data-scroll-target') === targetId;
      tab.classList.toggle('active', active);
      tab.setAttribute('aria-selected', active ? 'true' : 'false');
      tab.setAttribute('tabindex', active ? '0' : '-1');
    });

    if (keepNavigationVisible) {
      var navigation = document.getElementById('seller-navigation');
      if (navigation) {
        var rect = navigation.getBoundingClientRect();
        if (rect.top < 0 || rect.bottom > window.innerHeight) {
          navigation.scrollIntoView({ behavior: 'smooth', block: 'start' });
        }
      }
    }
  }

  document.addEventListener(
    'click',
    function (
      event
    ) {

      var button =
        event.target.closest(
          '[data-scroll-target]'
        );


      if (!button) {
        return;
      }


      event.preventDefault();


      var targetId =
        button.getAttribute(
          'data-scroll-target'
        );


      if (!targetId) {
        return;
      }


      activateSellerSection(targetId, true);

    }
  );


  /* =========================================================
     ACTIVE NAV WHILE PAGE SCROLLS
  ========================================================== */

  function initSellerSectionObserver() {

    var sections =
      Array.prototype.slice.call(
        document.querySelectorAll(
          '.seller-page-section'
        )
      )
      .filter(
        function (
          section
        ) {

          return (
            window.getComputedStyle(
              section
            ).display !==
            'none'
          );

        }
      );


    if (!sections.length) {
      return;
    }


    var observer =
      new IntersectionObserver(
        function (
          entries
        ) {

          var visibleEntries =
            entries
            .filter(
              function (
                entry
              ) {

                return (
                  entry.isIntersecting
                );

              }
            )
            .sort(
              function (
                a,
                b
              ) {

                return (
                  b.intersectionRatio -
                  a.intersectionRatio
                );

              }
            );


          if (
            !visibleEntries.length
          ) {
            return;
          }


          var sectionId =
            visibleEntries[0]
              .target
              .id;


          document
            .querySelectorAll(
              '.seller-tab'
            )
            .forEach(
              function (
                tab
              ) {

                tab.classList.remove(
                  'active'
                );

              }
            );


          var activeTab =
            document.querySelector(
              '[data-scroll-target="' +
              sectionId +
              '"]'
            );


          if (activeTab) {

            activeTab.classList.add(
              'active'
            );

          }

        },
        {
          root:
            null,

          rootMargin:
            '-145px 0px -55% 0px',

          threshold:
            [
              0,
              0.1,
              0.25,
              0.5
            ]
        }
      );


    sections.forEach(
      function (
        section
      ) {

        observer.observe(
          section
        );

      }
    );

  }


  /* =========================================================
     PRODUCT SEARCH EVENT
  ========================================================== */

  document.addEventListener(
    'input',
    function (
      event
    ) {

      if (
        event.target.id !==
        'seller-product-search'
      ) {
        return;
      }


      filterProducts(
        event.target.value
      );

    }
  );

  document.addEventListener('change', function (event) {
    if (event.target.id !== 'seller-product-sort') return;
    var search = document.getElementById('seller-product-search');
    filterProducts(search ? search.value : '');
  });

  document.addEventListener('click', function (event) {
    var sectionButton = event.target.closest('[data-seller-section]');
    if (sectionButton) {
      activeSellerSection = sectionButton.dataset.sellerSection || 'all';
      document.querySelectorAll('[data-seller-section]').forEach(function (button) {
        button.classList.toggle('active', button === sectionButton);
      });
      var search = document.getElementById('seller-product-search');
      filterProducts(search ? search.value : '');
      return;
    }

    var clearButton = event.target.closest('#seller-clear-filters');
    if (clearButton) {
      activeSellerSection = 'all';
      var searchInput = document.getElementById('seller-product-search');
      if (searchInput) searchInput.value = '';
      document.querySelectorAll('[data-seller-section]').forEach(function (button) {
        button.classList.toggle('active', button.dataset.sellerSection === 'all');
      });
      filterProducts('');
      return;
    }

    var filterToggle = event.target.closest('#seller-filter-toggle');
    if (filterToggle) {
      var sidebar = document.getElementById('seller-catalog-sidebar');
      if (!sidebar) return;
      var isOpen = sidebar.classList.toggle('open');
      filterToggle.setAttribute('aria-expanded', isOpen ? 'true' : 'false');
      filterToggle.textContent = isOpen ? 'Close Search & Filter' : 'Search & Filter';
    }
  });


  /* =========================================================
     START
  ========================================================== */

  showLoading();


  /*
   * No seller slug.
   */

  if (!vendorSlug) {

    showNotFound();

    return;

  }


  /*
   * Fetch seller information
   * from Django.
   */

  fetch(
    SELLER_API_BASE +
    encodeURIComponent(
      vendorSlug
    ) +
    '/',
    {
      method:
        'GET',

      headers:
        {
          'Accept':
            'application/json'
        },

      cache:
        'no-store'
    }
  )
  .then(
    function (
      response
    ) {

      if (!response.ok) {

        throw new Error(
          'Seller not found: ' +
          response.status
        );

      }


      return response.json();

    }
  )
  .then(
    function (
      data
    ) {

      if (!data) {

        showNotFound();

        return;

      }


      /*
       * Render all available Django data.
       */

      renderSellerProfile(
        data
      );


      /*
       * Show seller page.
       */

      showContent();

      /* Real tabs: show one content panel instead of stacking the full page. */
      activateSellerSection('seller-section-home', false);


      /*
       * Initialize scroll navigation
       * AFTER hidden sections have
       * been determined.
       */

      /* Scroll observation is unnecessary when only one tab panel is visible. */


      /*
       * Load Shopify products.
       */

      return loadShopifyProducts(
        data
      );

    }
  )
  .catch(
    function (
      error
    ) {

      console.error(
        '[Seller Storefront]',
        error
      );


      showNotFound();

    }
  );

})();
